// extracted by mini-css-extract-plugin
export default {"teamContainer":"Team_teamContainer__tSCl3","teamSection":"Team_teamSection__hDOuY","teamMobile":"Team_teamMobile__TmH0e"};